import {Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {AuthenticationService} from "../../modules/auth/_services/authentication.service";
import {MainTabsService} from "../../service/main-tabs.service";
import {CurrencyService} from "../../modules/currency/currency.service";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PopupComponent} from "../../shared/popup/popup.component";
import {LoaderService} from "../../service/loader.service";
import {PhoneMaskService} from "../../service/phoneMask.service";
import {ContactInfoService} from "../../service/contactInfo.service";
import {NavigationService} from "../../service/navigation.service";

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  infoForm: FormGroup;
  passwordForm: FormGroup;
  pinForm: FormGroup;

  numOfDigits = 4;
  phoneMask = this.phoneMaskService.setPhoneMask();

  @ViewChildren('inputs') inputs: QueryList<ElementRef>;
  constructor(private authenticationService: AuthenticationService,
              private mainTabsService: MainTabsService,
              private formBuilder: FormBuilder,
              private phoneMaskService: PhoneMaskService,
              private contactInfoService: ContactInfoService,
              private popupComponent: PopupComponent,
              private currencyService: CurrencyService,
              private loaderService: LoaderService,
              private navigationService: NavigationService) {

  }

  ngOnInit(): void {
    this.infoForm = this.formBuilder.group({
      first_name: [null, Validators.required],
      last_name: [null, Validators.required],
      email: [null, [Validators.required, Validators.pattern('^[0-9A-Za-z._%+-]+@[0-9A-Za-z.-]+\\.[a-zA-Z]{2,4}$')]],
    });

    this.passwordForm = this.formBuilder.group({
      oldPassword: [null, Validators.required],
      newPassword: [null, Validators.required],
      reEnteredPassword: [null, Validators.required],
    });

    this.pinForm = this.formBuilder.group({
      password: [null, Validators.required],
      digits: this.formBuilder.array([]),
    });
    for (let i = 0; i < this.numOfDigits; i++) {
      (this.pinForm.get('digits') as FormArray).push(this.formBuilder.control(null, Validators.required))
    }

    this.setUserInfo();

    this.scrollToTop();
  }

  scrollToTop() {
    const element = document.getElementById('settingsHeader');
    let elementPosition = element ? element.offsetTop : 0;
    document.querySelector('.main__inner').scrollTo({
      top: elementPosition - 10, //add your necessary value
      behavior: "smooth"  //Smooth transition to roll
    });
  }

  setUserInfo() {
    const firstName = this.authenticationService.getCurrentUserFirstName();
    const lastName = this.authenticationService.getCurrentUserLastName();
    const email = this.authenticationService.getCurrentUserEmail();
    if (firstName) {
      this.infoForm.controls.first_name.setValue(firstName);
    }
    if (lastName) {
      this.infoForm.controls.last_name.setValue(lastName);
    }
    if (email) {
      this.infoForm.controls.email.setValue(email);
    }
  }

  getPhone() {
    return this.authenticationService.getCurrentUserPhone();
  }

  isInfoUpdateBtnDisabled() {
    const firstNameSaved = this.authenticationService.getCurrentUserFirstName();
    const lastNameSaved = this.authenticationService.getCurrentUserLastName();
    const emailSaved = this.authenticationService.getCurrentUserEmail();
    const firstName = this.infoForm.controls.first_name.value;
    const lastName = this.infoForm.controls.last_name.value;
    const email = this.infoForm.controls.email.value;
    return (firstNameSaved === firstName) &&
           (lastNameSaved === lastName) &&
           (emailSaved === email);
  }

  onSubmitInfoForm() {
    if (this.isInfoUpdateBtnDisabled()) {
      return;
    }
    const firstName = this.infoForm.controls.first_name.value;
    const lastName = this.infoForm.controls.last_name.value;
    const email = this.infoForm.controls.email.value;
    this.contactInfoService.saveUserContacts(firstName, lastName, email).subscribe(data => {
      try {
        if (data.status) {
          this.popupComponent.showPopupSuccess({text: data.message});
          this.authenticationService.refreshTokenNow();
        } else {
          this.popupComponent.showPopupError({text: data.message});
        }
      } catch (e) {
        this.loaderService.hideAndShowTryAgain();
      }
    }, (error) => {
      this.loaderService.hideAndShowTryAgain();
    }, () => {
      this.loaderService.hide();
    });
  }

  isPasswordUpdateBtnDisabled() {
    const oldPassword = this.passwordForm.controls.oldPassword.value;
    const newPassword = this.passwordForm.controls.newPassword.value;
    const reEnteredPassword = this.passwordForm.controls.reEnteredPassword.value;
    return !oldPassword || !newPassword || (newPassword !== reEnteredPassword);
  }

  isPinUpdateBtnDisabled() {
    const password = this.pinForm.controls.password.value;
    return !password || this.pinForm.controls.digits.invalid;
  }

  resetPinInput() {
    (this.pinForm.get('digits') as FormArray).clear();
    for (let i = 0; i < this.numOfDigits; i++) {
      (this.pinForm.get('digits') as FormArray).push(this.formBuilder.control(null, Validators.required))
    }
  }

  check(index, field, event) {
    if (isNaN(parseInt(event.key, 10)) && event.key !== 'Backspace') {
      event.preventDefault();
    }

    if (field.value && event.key !== 'Backspace') {
      if (index < this.inputs.toArray().length - 1) {
        this.inputs.toArray()[index + 1].nativeElement.focus();
      }
    } else if (event.key === 'Backspace') {
      if (index > 0) {
        field.setValue(null)
        this.inputs.toArray()[index - 1].nativeElement.focus();
      } else {
        console.log('first field');
      }
    }
  }

  onSubmitPasswordForm() {
    const oldPassword = this.passwordForm.controls.oldPassword.value;
    const newPassword = this.passwordForm.controls.newPassword.value;
    this.contactInfoService.onChangePassword(oldPassword, newPassword).subscribe(data => {
      try {
        if (data.status) {
          this.popupComponent.showPopupSuccess({text: data.message});
          this.passwordForm.reset();
        } else {
          this.popupComponent.showPopupError({text: data.message});
        }
      } catch (e) {
        this.loaderService.hideAndShowTryAgain();
      }
    }, (error) => {
      this.loaderService.hideAndShowTryAgain();
    }, () => {
      this.loaderService.hide();
    });
  }

  onSubmitPinForm() {
    const password = this.pinForm.controls.password.value;
    let pin = this.pinForm.controls.digits.value;
    pin = pin.join('');
    this.contactInfoService.onChangePin(pin, password).subscribe(data => {
      try {
        if (data.status) {
          this.popupComponent.showPopupSuccess({text: data.message});
          this.pinForm.reset();
        } else {
          this.popupComponent.showPopupError({text: data.message});
        }
      } catch (e) {
        this.loaderService.hideAndShowTryAgain();
      }
    }, (error) => {
      this.loaderService.hideAndShowTryAgain();
    }, () => {
      this.loaderService.hide();
    });
  }

  goBack() {
    this.navigationService.goToHomePage();
  }
}
